import { render } from "./distributor_banks_form.vue?vue&type=template&id=9a81eb4c&scoped=true"
import script from "./distributor_banks_form.vue?vue&type=script&lang=js"
export * from "./distributor_banks_form.vue?vue&type=script&lang=js"

import "./distributor_banks_form.vue?vue&type=style&index=0&id=9a81eb4c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a81eb4c"]])

export default __exports__